import Natureza from './natureza'
import NCM from './ncm'
import Lei from './lei'
import CST from './cst'

export default class PISCOFINS {
  constructor(
    id,
    descricao,
    observacao,
    percentualPISEntrada,
    percentualCOFINSEntrada,
    percentualPISSaida,
    percentualCOFINSSaida
  ) {
    this.id = id
    this.descricao = descricao
    this.observacao = observacao
    this.percentualPISEntrada = percentualPISEntrada
    this.percentualCOFINSEntrada = percentualCOFINSEntrada
    this.ncm = new NCM()
    this.lei = new Lei()
    this.naturezaEntrada = new Natureza()
    this.percentualPISSaida = percentualPISSaida
    this.percentualCOFINSSaida = percentualCOFINSSaida
    this.cstEntrada = new CST()
    this.cstSaida = new CST()
    this.naturezaSaida = new Natureza()
  }
}
